export class ProductCardModel {
 cardTitle: string;
 mediaType: string;
 imageSrc: string;
 smallImageSrc: string;
 description: string;
 descriptionStyle: string;
 buttonName: string;
 activetab: boolean;
 price: string;
 link: string;

constructor() {
    this.cardTitle = undefined;
    this.mediaType = undefined;
    this.imageSrc = undefined;
    this.smallImageSrc = undefined;
    this.description = undefined;
    this.descriptionStyle = undefined;
    this.buttonName = undefined;
    this.activetab = undefined;
    this.price = undefined;
    this.link = undefined;
  }
}
